import React from "react";
import { ctaComponentAlignment } from "./CTAComponentConstants";
import PropTypes from "prop-types";
import CenterAlign from "./CenterAlign";
import LeftAlign from "./LeftAlign";
import { useGlobalContext } from "../Context";
var CTAComponent = function (_a) {
    var alignment = _a.alignment, backgroundColor = _a.backgroundColor, buttonColor = _a.buttonColor, buttonLink = _a.buttonLink, buttonText = _a.buttonText, buttonTarget = _a.buttonTarget, buttonTextColor = _a.buttonTextColor, header = _a.header, headerImageCenterLayout = _a.headerImageCenterLayout, subImage = _a.subImage, subText = _a.subText, textColor = _a.textColor, topImage = _a.topImage, vendor = _a.vendor;
    var context = useGlobalContext();
    if (vendor !== context.vendor) {
        return null;
    }
    if (alignment === ctaComponentAlignment.center) {
        return (React.createElement(CenterAlign, { backgroundImageDesktop: topImage ? topImage.fields.file.url : null, backgroundImageMobile: subImage ? subImage.fields.file.url : null, headerImage: headerImageCenterLayout
                ? headerImageCenterLayout.fields.file.url
                : null, backgroundColor: backgroundColor, buttonColor: buttonColor, buttonLink: buttonLink, buttonTarget: buttonTarget, buttonText: buttonText, buttonTextColor: buttonTextColor, textColor: textColor, header: header, subtext: subText }));
    }
    if (alignment === ctaComponentAlignment.left) {
        return (React.createElement(LeftAlign, { headerImage: headerImageCenterLayout
                ? headerImageCenterLayout.fields.file.url
                : null, backgroundColor: backgroundColor, buttonColor: buttonColor, buttonLink: buttonLink, buttonTarget: buttonTarget, buttonText: buttonText, buttonTextColor: buttonTextColor, textColor: textColor, header: header, subText: subText, subImage: subImage, topImage: topImage }));
    }
    return React.createElement("div", null);
};
CTAComponent.defaultProps = {
    alignment: "left",
    backgroundColor: "#6b69695e",
};
CTAComponent.propTypes = {
    alignment: PropTypes.string.isRequired,
    subText: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonColor: PropTypes.string.isRequired,
    buttonLink: PropTypes.string.isRequired,
};
export default CTAComponent;
